import { UpdateEmployeeCostsComponent } from "./pages/update-real-costs/update-employee-costs.component";
import { AuthGuard } from "../../auth/helpers";
import { ListEmployeesCostsComponent } from "./pages/list-employees-costs/list-employees-costs.component";
import { UpdateContractCostsComponent } from "./pages/update-contract-costs/update-contract-costs.component";
import EmployeeTfrAmountComponent from "./pages/employee-tfr-amount/employee-tfr-amount.component";

const employeeCostsRoutes = [
  {
    path: "dashboard/update-employee-costs",
    component: UpdateEmployeeCostsComponent,
    capability: "update_employee_monthly_costs",
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/list-employee-costs",
    component: ListEmployeesCostsComponent,
    capability: "view_employee_monthly_costs",
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/update-employees-contracts-costs",
    component: UpdateContractCostsComponent,
    capability: "update_employee_contract_costs",
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/update-employees-tfr-amount",
    component: EmployeeTfrAmountComponent,
    capability: "update_employee_tfr_amount",
    canActivate: [AuthGuard],
  },
];

export default employeeCostsRoutes;
